import AdminLayerBlueprint from "components/blueprints/AdminLayerBlueprint";
import React from "react";
import AdminAnalyticsOverview from "./AdminAnalyticsOverview";

function AdminAnalyticsPage() {
  return (
    <div className="min-h-screen bg-gray-100 py-2">
      <div className="container mx-auto my-6 flex">
        <section className="w-full">
          <AdminAnalyticsOverview />
        </section>
      </div>
    </div>
  );
}

export default AdminLayerBlueprint(AdminAnalyticsPage);
